import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth/auth';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PasswordResetRequestsService } from '../../../services/password-reset-requests/password-reset-requests';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.html',
  styleUrl: './login.css',
})

export class Login {
  email = '';
  password = '';
  loading = false;
  errorMessage = '';

  resetEmail = '';
  submittingResetRequest = false;

  constructor(
    private authService: AuthService,
    private passwordResetRequestsService: PasswordResetRequestsService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  submit(): void {
    this.errorMessage = '';

    if (!this.email || !this.password) {
      this.errorMessage = 'Email and password are required.';
      this.toastr.warning(
        'Please enter your email and password.',
        'Validation'
      );
      return;
    }

    this.loading = true;

    this.authService.login({
      email: this.email,
      password: this.password
    }).subscribe({
      next: response => {
        this.loading = false;

        if (!response.success || !response.data) {
          this.errorMessage = response.message || 'Login failed.';
          return;
        }

        this.toastr.success(
          'Welcome back.',
          'Login Successful'
        );

        this.router.navigate(['/dashboard']);
      },
      error: error => {
        this.loading = false;
        this.toastr.error(
          error?.error?.message ||
          error?.error?.error?.details ||
          'Login failed.',
          'Authentication Failed'
        );
      }
    });
  }

  submitPasswordResetRequest(): void {
    if (!this.resetEmail.trim()) {
      this.toastr.warning('Email is required.', 'Validation');
      return;
    }

    this.submittingResetRequest = true;

    this.passwordResetRequestsService.create(this.resetEmail.trim()).subscribe({
      next: response => {
        this.submittingResetRequest = false;

        if (!response.success || !response.data) {
          this.toastr.error(response.message || 'Unable to submit password reset request.');
          return;
        }

        this.toastr.success(
          'Password reset request submitted. An administrator will review it.',
          'Request Submitted'
        );

        this.resetEmail = '';

        const modalEl = document.getElementById('forgotPasswordModal');
        const modal = (window as any).bootstrap.Modal.getInstance(modalEl);
        modal?.hide();
      },
      error: error => {
        this.submittingResetRequest = false;

        this.toastr.error(
          error?.error?.message ||
          error?.error?.error?.details ||
          'Unable to submit password reset request.',
          'Password Reset'
        );
      }
    });
  }
}